import { sendSlackMessage } from '@/apis/slack.api';

export const sendSlackError = async (batchPayload) => {
  const isProd = process.env.NODE_ENV === 'production';

  if (!isProd) {
    console.warn('[Dev Mode] Slack 전송 생략:', batchPayload);

    return;
  }

  const message = formatBatchMessage(batchPayload);

  try {
    await sendSlackMessage(message);
  } catch (err) {
    console.warn('[Slack 전송 실패]', err);
  }
};

const formatBatchMessage = (batchPayload) => {
  const siteName = process.env.VUE_APP_SITE_NAME;
  const { errors, batchSize, batchTimestamp } = batchPayload;

  // 첫 번째 에러에서 공통 정보 추출
  const firstError = errors[0];
  const { url, user } = firstError;

  let message = `🚨 *[${siteName}]*\n`;
  message += `📆 Batch Time: ${batchTimestamp}\n`;
  message += `🌐 URL: ${url}\n`;
  message += `👤 User: \`${JSON.stringify(user)}\`\n`;
  message += `🔢 Total Errors: ${batchSize}\n\n`;

  errors.forEach((error, index) => {
    const { message: errorMessage, timestamp, stack } = error;
    const isLast = index === errors.length - 1;

    message += `📋 *Error ${index + 1}:*\n`;
    message += `⏰ ${timestamp}\n`;
    message += `🧾 ${errorMessage}\n`;

    if (stack) {
      message += `\`\`\`\n${stack}\n\`\`\``;
    } else {
      message += `No stack trace`;
    }

    // 마지막이 아닌 경우에만 구분선 추가
    if (!isLast) {
      message += `\n\n---\n\n`;
    }
  });

  return message.trim();
};
